import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-pagination-dark',
  templateUrl: './pagination-dark.component.html',
  styleUrls: ['../../scss/office.scss']
})
export class PaginationDarkComponent {

  @Input() page: number;
  @Input() count: number;
  @Input() perPage: number;
  @Input() pagesToShow: number;
  @Input() loading: boolean;
  @Input() dialogFlag = false;

  @Output() goPrev = new EventEmitter<boolean>();
  @Output() goNext = new EventEmitter<boolean>();
  @Output() goPage = new EventEmitter<number>();
  @Output() goPerPage = new EventEmitter<number>();

  curPage = -1;

  onPage(n: number): void {
    this.goPage.emit(n-2);
    this.curPage = n-2;
  }

  toFirst(): void {
    this.curPage = -1;
    this.goPage.emit(this.curPage);

  }

  toPrev(): void {
    if(this.curPage >= 0) {
      this.curPage--;
      this.goPage.emit(this.curPage);
    }

  }

  toNext(): void {
    if(this.curPage < this.totalPages() -2) {
      this.curPage++;
      this.goPage.emit(this.curPage);
    }

  }

  toLast(): void {
    this.goPage.emit(this.totalPages() - 2);
  }

  onPrev(): void {
    if (this.page >= 1) {
      this.goPrev.emit(true);
      this.curPage--;
    }
  }

  onNext(next: boolean): void {
    if (this.totalPages() > this.page + 1) {
      this.goNext.emit(next);
      this.curPage++;
    }
  }

  totalPages(): number {
    return Math.ceil(this.count / this.perPage) || 0;
  }

  getPages(): number[] {
    const c = Math.ceil(this.count / this.perPage);
    const p = this.page || 1;
    const pagesToShow = this.pagesToShow || 9;
    const pages: number[] = [];
    pages.push(p);
    const times = pagesToShow - 1;
    for (let i = 0; i < times; i++) {
      if (pages.length < pagesToShow) {
        if (Math.min.apply(null, pages) > 1) {
          pages.push(Math.min.apply(null, pages) - 1);
        }
      }
      if (pages.length < pagesToShow) {
        if (Math.max.apply(null, pages) < c) {
          pages.push(Math.max.apply(null, pages) + 1);
        }
      }
    }
    pages.sort((a, b) => a - b);
    return pages;
  }

  onPerPageChange(perPage: any) {
    this.goPerPage.emit(perPage);
    this.perPage = perPage;
    this.curPage = -1;
    this.toFirst();
  }
}
